module.exports = __webpack_public_path__ + "static/media/34DSS7.2d3623b1.jpg";